module.exports = __webpack_public_path__ + "static/media/OpenSans-Light.5193f01d.woff";